import { getCurrentLanguage, setCurrentLanguage } from '@/utils/LanguageUtil'

export default {
  state: {
    lang: getCurrentLanguage()
  },
  getters: {
    isEnglish(state) {
      return state.lang === 'en-US'
    }
  },
  mutations: {
    setLanguage(state, lang) {
      state.lang = lang
    }
  },
  actions: {
    setLang({ commit }, lang) {
      setCurrentLanguage(lang)
      commit('setLanguage', lang)
    }
  }
}

